import {create} from 'zustand';

type CardGroupStore = {
  groupCode: string;
  cardId: string;
  setGroupCode: (groupCode: string) => void;
  setCardId: (cardId: string) => void;
};

export const useCardGroupStore = create<CardGroupStore>((set) => ({
  groupCode: '',
  cardId: '',
  setGroupCode: (groupCode) => set({groupCode}),
  setCardId: (cardId) => set({cardId})
}));
